// ============================================================================
//  Alpha Omega 1N Logic — JS entry point
//  Imports the stylesheet (so Vite compiles/injects it) and initializes each
//  behavior module. Each module is self-contained and no-ops gracefully if its
//  target element is absent, so partial builds don't throw.
// ============================================================================
import '../scss/main.scss';

import { initNav } from './modules/nav.js';
import { initParticleMesh } from './modules/particle-mesh.js';
import { initPatentViewer } from './modules/patent-viewer.js';
import { initScrollReveal } from './modules/scroll-reveal.js';
import { initParallax } from './modules/parallax.js';
import { initAccordion } from './modules/accordion.js';

const prefersReducedMotion = window.matchMedia(
  '(prefers-reduced-motion: reduce)'
).matches;

function boot() {
  initNav();
  initPatentViewer();
  initParticleMesh({ reducedMotion: prefersReducedMotion });
  initScrollReveal({ reducedMotion: prefersReducedMotion });
  initParallax({ reducedMotion: prefersReducedMotion });
  initAccordion({ reducedMotion: prefersReducedMotion });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot, { once: true });
} else {
  boot();
}
